import { registerAction } from '../../Action'

const LOAD_STORIES = 'LOAD_STORIES'

const reducer = (state = {}, action) => ({
  ...state,
  stories: action.payload,
  stories_loaded: true,
})

const loadStories = registerAction(LOAD_STORIES, { reducer })

export default loadStories
